module.exports = __webpack_public_path__ + "img/fixed-banner.7b89d772.png";